<template>
  <div id="schedule">
    <ul class="w-full">
      <li v-for="(day, index) in weekDays" :key="`weekDay-${day.value}`">
        <div class="w-full flex mb-5">
          <div class="w-4/12 flex flex-column align-center">
            <vs-checkbox v-model="weekDays[index].selected">{{ day.label }}</vs-checkbox>
          </div>
          <div v-if="weekDays[index].selected" class="w-full flex flex-column align-center">
            <div>
              <flat-pickr
                :config="configdateTimePicker"
                v-model="weekDays[index].start_at"
                placeholder="Abertura"
                class="mr-5"
                style="width: 10em;"
              />

              <flat-pickr
                v-if="useSchedulingPause && useSchedulingDayPause(weekDays[index])"
                :config="finishAtConfig(configdateTimePicker, weekDays[index].start_at, weekDays[index].finish_at)"
                v-model="weekDays[index].start_pause"
                placeholder="Inicio Pausa"
                class="mr-5"
                style="width: 10em;"
              />

              <span v-if="useSchedulingPause && useSchedulingDayPause(weekDays[index])" class="mr-5">
                Pausa
              </span>

              <flat-pickr
                v-if="useSchedulingPause && useSchedulingDayPause(weekDays[index])"
                :config="finishAtConfigMinMax(configdateTimePicker, weekDays[index].start_pause, weekDays[index].finish_at)"
                v-model="weekDays[index].finish_pause"
                placeholder="Final da Pausa"
                class="mr-5"
                :disabled="weekDays[index].start_pause === null"
                style="width: 10em;"
              />

              <flat-pickr
                :config="finishAtConfig(configdateTimePicker)"
                v-model="weekDays[index].finish_at"
                placeholder="Fechamento"
                :disabled="weekDays[index].start_at === null"
                class="mr-5"
                style="width: 10em;"
              />
            </div>

            <feather-icon v-if="useSchedulingPause && useSchedulingDayPause(weekDays[index])" icon="XIcon" svgClasses="h-4 w-4" style="cursor: pointer;" @click="removeSchudulePauseDay(weekDays[index])"/>
            <vs-button
              v-if="useSchedulingPause && !useSchedulingDayPause(weekDays[index])"
              size="small"
              icon="add"
              style="transform: translateY(0.5em); width: 1em;"
              @click="removeDaysOnEmptyDaysSelected(weekDays[index])"
            />
          </div>
        </div>
      </li>
    </ul>

    <div v-if="useMessageShield">
      <div class="w-full mt-8">
        <label>Mensagem para enviar fora do horário de atendimento</label>
        <vs-textarea v-model="messages['message']" class="mt-3"></vs-textarea>
      </div>
      <div v-if="useSchedulingPause" class="w-full mt-8">
        <label>Mensagem para enviar durante o intervalo do bot no horário de atendimento</label>
        <vs-textarea v-model="messages['message_pause']" class="mt-3"></vs-textarea>
      </div>
    </div>
  </div>
</template>

<script>
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'

export default {
  name: "bot-schedule",
  components: { flatPickr },
  props: {
    useSchedulingPause: {
      required: true,
      default(){ return false; }
    },
    useMessageShield: {
      required: false,
      default(){ return false; }
    },
    userDepartmentId: {
      required: false,
      default(){ return null; }
    },
    messages: {
      required: false,
      default(){ return []; }
    },
    weekDays: {
      required: false,
      default(){
        return this.defaultValue;
      }
    }
  },
  data(){
    return {
      emptyDaysSelected: [],
      defaultValue: [
        { value: '1', label: 'Segunda-feira', start_at: '00:00', finish_at: '00:00', selected: false, start_pause: '00:00', finish_pause: '00:00' },
        { value: '2', label: 'Terça-feira',   start_at: '00:00', finish_at: '00:00', selected: false, start_pause: '00:00', finish_pause: '00:00' },
        { value: '3', label: 'Quarta-feira',  start_at: '00:00', finish_at: '00:00', selected: false, start_pause: '00:00', finish_pause: '00:00' },
        { value: '4', label: 'Quinta-feira',  start_at: '00:00', finish_at: '00:00', selected: false, start_pause: '00:00', finish_pause: '00:00' },
        { value: '5', label: 'Sexta-feira',   start_at: '00:00', finish_at: '00:00', selected: false, start_pause: '00:00', finish_pause: '00:00' },
        { value: '6', label: 'Sábado',        start_at: '00:00', finish_at: '00:00', selected: false, start_pause: '00:00', finish_pause: '00:00' },
        { value: '0', label: 'Domingo',       start_at: '00:00', finish_at: '00:00', selected: false, start_pause: '00:00', finish_pause: '00:00' },
      ],
      configdateTimePicker: {
        enableTime: true,
        noCalendar: true,
        dateFormat: "H:i",
        time_24hr: true
      }
    }
  },
  watch:{
    useSchedulingPause() {
      if ( !this.useSchedulingPause ) {
        this.weekDays.forEach(weekDay => {
          weekDay.start_pause = '00:00'
          weekDay.finish_pause = '00:00'
        })
      }
    },
    weekDays: {
      handler() {
        setTimeout(() => {
          this.$emit('updatedWeekDays', this.weekDays, this.userDepartmentId)
        }, 100)
      },
      immediate: true,
      deep: true
    },
    messages: {
      handler() {
        setTimeout(() => {
          this.$emit('updatedMessages', this.messages, this.userDepartmentId)
        }, 100)
      },
      immediate: true,
      deep: true
    }
  },
  methods:{
    finishAtConfig(config, minDate = null, maxDate = null) {
      return {
        ...config,
        minDate,
        maxDate
      }
    },
    finishAtConfigMinMax(config, minDate, maxDate) {
      return {
        ...config,
        minDate,
        maxDate
      }
    },
    weekDaysEnabled(value) {
      this.weekDays.forEach(weekDay => {
        if (weekDay.value === value) {
          if (weekDay.start_pause == '00:00' && weekDay.finish_pause == '00:00') {
            if (!this.emptyDaysSelected.includes(weekDay)) {
              this.emptyDaysSelected.push(weekDay)
            }
          }
        }
      })
    },
    useSchedulingDayPause(data) {
      if (data) {
        this.weekDaysEnabled(data.value);
        if (this.emptyDaysSelected.includes(data)) { return false }
      }

      return true
    },
    removeSchudulePauseDay(day) {
      this.weekDays[parseInt(day.value) === 0 ? 6 : parseInt(day.value) - 1].start_pause  = '00:00'
      this.weekDays[parseInt(day.value) === 0 ? 6 : parseInt(day.value) - 1].finish_pause = '00:00'
    },
    removeDaysOnEmptyDaysSelected(day) {
      if (this.emptyDaysSelected.includes(day)) {
        this.emptyDaysSelected.splice(this.emptyDaysSelected.indexOf(day), 1)

        this.weekDays.map((date) => {
          if (date.value === day.value) {
            date.start_pause  = null
            date.finish_pause = null
          }
        })
      }
    }
  },
  created() {
    if (!this.weekDays) {
      this.weekDays = this.defaultValue;
    }
    if (!this.messages) {
      this.messages = []
    }
  }
}
</script>

<style lang="scss">
#schedule{
  width: 100% !important;
}
</style>